import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=58095847&scoped=true&"
import script from "./LoginButton.vue?vue&type=script&lang=ts&"
export * from "./LoginButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoginButton.vue?vue&type=style&index=0&id=58095847&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58095847",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58095847')) {
      api.createRecord('58095847', component.options)
    } else {
      api.reload('58095847', component.options)
    }
    module.hot.accept("./LoginButton.vue?vue&type=template&id=58095847&scoped=true&", function () {
      api.rerender('58095847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LoginButton.vue"
export default component.exports